import { useMemo, useState } from "react";
import { Button, Divider } from "antd";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styles from './style.module.scss'
import { BasicInfoSection } from "./BasicInfoSection";
import { UserConditionsSection } from "./UserConditionsSection";
import { DiscountDetailsSection } from "./DiscountDetailsSection";
import { AdditionalSettingsSection } from "./AdditionalSettingsSection";
import { ProviderDetailsSection } from "./ProviderDetailsSection";

export const FormWithSteps = ({ methods, onSubmit, enableUserConditions, loadingSubmit = false }) => {
    const steps = useMemo(() => {
        const baseSteps = [
            { title: "basic_info", key: "basic_info" },
            { title: "provider_details", key: "provider_details" },
            enableUserConditions && { title: "user_conditions", key: "user_conditions" },
            { title: "discount_details", key: "discount_details" },
            { title: "additional_settings", key: "additional_settings" },
        ];
        return baseSteps.filter(Boolean); 
    }, [enableUserConditions]);

    const { t } = useTranslation();
    const [currentStep, setCurrentStep] = useState(0);

    const isLastStep = currentStep === steps.length - 1;

    const handleNext = async () => {
        const isValid = await methods.trigger();
        if (isValid) {
            if (!isLastStep) {
                setCurrentStep((prev) => prev + 1);
            } else {
                await onSubmit(methods.getValues());
            }
        }
    };

    const handleBack = () => {
        if (currentStep > 0) {
            setCurrentStep((prev) => prev - 1);
        }
    };

    return (
        <FormProvider {...methods}>
            <form className={styles.container} >
                <div className={styles.children}>
                    {steps[currentStep].key === "basic_info" && <BasicInfoSection control={methods.control} setValue={methods.setValue} />}
                    {steps[currentStep].key === "provider_details" && <ProviderDetailsSection control={methods.control} />}
                    {steps[currentStep].key === "user_conditions" && enableUserConditions && <UserConditionsSection control={methods.control} />}
                    {steps[currentStep].key === "discount_details" && <DiscountDetailsSection control={methods.control} setValue={methods.setValue} />}
                    {steps[currentStep].key === "additional_settings" && <AdditionalSettingsSection setValue={methods.setValue} />}
                </div>
                <div style={{ marginTop: 24 }}>
                    <Divider />
                    <div className={styles.formFooter}>
                        {currentStep > 0 && (
                            <Button onClick={handleBack} style={{ marginRight: 8 }} disabled={loadingSubmit}>
                                {t("back")}
                            </Button>
                        )}
                        <Button type="primary" onClick={handleNext} loading={isLastStep && loadingSubmit}>
                            {isLastStep ? t("save") : t("next")}
                        </Button>
                    </div>
                </div>
            </form>
        </FormProvider>
    );
};
